import ActionTypeZona from "../ActionTypeZona";
// import {ModosOp} from '../../Constantes'
// import Estado from '../EstadoDialogoClienteAFacturar'

export default class CargaDeErroresDelDominioAlActualizarZona extends ActionTypeZona {

    ejecutar(estado, nuevoEstado) {

        for (const property in nuevoEstado.error) {
            nuevoEstado.error[property]=false;
        }

        this.payload.errores.forEach( (error) => {
            nuevoEstado.error[error]=true;
        });

        nuevoEstado.flag.procesandoComando = false;
        return nuevoEstado;
    }

}